import { NavLink } from 'react-router-dom';
import SvgIcon from 'components/SvgIcon';
import { ROUTES } from 'app/routes';
import { useAppSelector } from 'app/hooks';
import { selectUser } from 'features/auth';
import { AccountTypes } from 'features/account-setup/types';
import './MobileFooterNav.scss';

type Props = {
  sidebarOpen: boolean;
  toggleSidebar(): void;
};

const UserMobileFooterNav = ({ sidebarOpen, toggleSidebar }: Props) => {
  const user = useAppSelector(selectUser);
  const isEmployer = user?.activeAccountType === AccountTypes.Employer;
  const closeIfOpen = () => { if (sidebarOpen) toggleSidebar(); };

  return (
    <nav className="mobile-footer-nav">
      {isEmployer ? (
        <NavLink exact to={ROUTES.JOB_POSTS} className="mobile-footer-nav-item" activeClassName="active" onClick={closeIfOpen}>
          <SvgIcon name="sidebar/job-templates" />
        </NavLink>
      ) : (
        <NavLink exact to={ROUTES.JOB_SEEKERS} className="mobile-footer-nav-item" activeClassName="active" onClick={closeIfOpen}>
          <SvgIcon name="sidebar/job-seekers" />
        </NavLink>
      )}
      <NavLink exact to={isEmployer ? ROUTES.EXPLORE_PROGRAMS : ROUTES.PROGRAM_PAGE} className="mobile-footer-nav-item" activeClassName="active" onClick={closeIfOpen}>
        <SvgIcon name="sidebar/programs" />
      </NavLink>
      <NavLink exact to={isEmployer ? ROUTES.EXPLORE_PROGRAM_NETWORKS : ROUTES.PROGRAM_NETWORKS_PAGE} className="mobile-footer-nav-item" activeClassName="active" onClick={closeIfOpen}>
        <SvgIcon name="sidebar/networks" />
      </NavLink>
      <button className={`mobile-footer-nav-item${sidebarOpen ? ' active' : ''}`} onClick={toggleSidebar}>
        <SvgIcon name="sidebar/toggle-sidebar" />
      </button>
    </nav>
  );
};

export default UserMobileFooterNav;
